import React, { useState } from "react";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaGraduationCap,
  FaArrowRight,
  FaPaperPlane,
  FaChevronRight,
  FaClock,
  FaHeart,
  FaBriefcase,
  FaUsers,
  FaLightbulb,
  FaCheckCircle,
  FaBullseye,
  FaCertificate,
  FaGlobeAfrica,
} from "react-icons/fa";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email.trim()) return;

    setSubscribed(true);
    setEmail("");

    setTimeout(() => {
      setSubscribed(false);
    }, 3500);
  };

  return (
    <footer className="patif-footer">
      <style>{`
        /* =========================================================
           PASSION AIDS THE FUTURE — FOOTER
        ========================================================= */

        .patif-footer {
          --patif-black: #070908;
          --patif-black-soft: #101411;
          --patif-black-light: #151a16;

          --patif-green-dark: #0b5d2a;
          --patif-green: #16803a;
          --patif-green-bright: #20a84a;

          --patif-lemon: #c8f23a;
          --patif-lemon-bright: #b7f000;

          --patif-yellow: #f5d32f;
          --patif-yellow-bright: #ffe45a;

          --patif-white: #ffffff;
          --patif-white-soft: #edf2ed;

          --patif-muted: #9ca69f;
          --patif-muted-light: #c6cec8;

          position: relative;
          width: 100%;
          overflow: hidden;
          background: var(--patif-black);
          color: var(--patif-white);
          font-family:
            "Poppins",
            "Segoe UI",
            Arial,
            sans-serif;
        }

        /* =========================================================
           TOP BRAND ACCENT
        ========================================================= */

        .patif-footer-accent {
          display: grid;
          grid-template-columns: 1fr 2fr 1fr;
          width: 100%;
          height: 6px;
        }

        .patif-footer-accent span:nth-child(1) {
          background: var(--patif-green);
        }

        .patif-footer-accent span:nth-child(2) {
          background: var(--patif-lemon);
        }

        .patif-footer-accent span:nth-child(3) {
          background: var(--patif-yellow);
        }

        /* =========================================================
           MAIN FOOTER
        ========================================================= */

        .patif-footer-main {
          position: relative;
          display: grid;
          grid-template-columns: 1.35fr 0.9fr 1.1fr;
          gap: 58px;
          max-width: 1480px;
          margin: 0 auto;
          padding: 78px 55px 68px;
        }

        .patif-footer-main::before {
          content: "";
          position: absolute;
          width: 430px;
          height: 430px;
          right: -220px;
          top: -210px;
          border: 1px solid rgba(200, 242, 58, 0.08);
          border-radius: 50%;
          pointer-events: none;
        }

        .patif-footer-main::after {
          content: "";
          position: absolute;
          width: 280px;
          height: 280px;
          right: -120px;
          top: -130px;
          border: 1px solid rgba(32, 168, 74, 0.12);
          border-radius: 50%;
          pointer-events: none;
        }

        /* =========================================================
           BRAND SECTION
        ========================================================= */

        .patif-footer-brand-section {
          position: relative;
          z-index: 2;
        }

        .patif-footer-brand {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 24px;
        }

        .patif-footer-brand-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 60px;
          height: 60px;
          flex-shrink: 0;

          border: 1px solid rgba(200, 242, 58, 0.25);
          border-radius: 14px;

          background:
            linear-gradient(
              145deg,
              var(--patif-lemon),
              var(--patif-yellow)
            );

          color: var(--patif-black);
          font-size: 27px;

          box-shadow:
            0 10px 30px rgba(200, 242, 58, 0.13);

          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
        }

        .patif-footer-brand:hover .patif-footer-brand-icon {
          transform: translateY(-4px);
          box-shadow:
            0 15px 35px rgba(200, 242, 58, 0.2);
        }

        .patif-footer-brand-text h2 {
          margin: 0 0 5px;
          color: var(--patif-white);
          font-size: 21px;
          font-weight: 850;
          line-height: 1.15;
          letter-spacing: -0.5px;
          text-transform: uppercase;
        }

        .patif-footer-brand-text span {
          color: var(--patif-lemon);
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 1.5px;
          text-transform: uppercase;
        }

        .patif-footer-description {
          max-width: 570px;
          margin: 0 0 28px;
          color: var(--patif-muted-light);
          font-size: 13.5px;
          line-height: 1.9;
        }

        /* =========================================================
           BRAND VALUES
        ========================================================= */

        .patif-footer-values {
          display: flex;
          flex-wrap: wrap;
          gap: 9px;
          margin-bottom: 28px;
        }

        .patif-footer-value {
          display: inline-flex;
          align-items: center;
          gap: 8px;

          padding: 9px 12px;

          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 7px;

          background: rgba(255, 255, 255, 0.035);

          color: #dce3dd;
          font-size: 11px;
          font-weight: 650;

          transition:
            border-color 0.3s ease,
            background 0.3s ease,
            transform 0.3s ease;
        }

        .patif-footer-value svg {
          color: var(--patif-lemon);
          font-size: 12px;
        }

        .patif-footer-value:hover {
          border-color: rgba(200, 242, 58, 0.35);
          background: rgba(200, 242, 58, 0.06);
          transform: translateY(-2px);
        }

        /* =========================================================
           INSTITUTIONAL BADGE
        ========================================================= */

        .patif-footer-institution-badge {
          display: inline-flex;
          align-items: center;
          gap: 9px;

          margin-bottom: 30px;
          padding: 10px 14px;

          border-left: 3px solid var(--patif-lemon);
          background: rgba(22, 128, 58, 0.15);

          color: #e0e7e1;
          font-size: 10.5px;
          font-weight: 650;
          line-height: 1.4;
        }

        .patif-footer-institution-badge svg {
          color: var(--patif-lemon);
          flex-shrink: 0;
        }

        /* =========================================================
           SOCIAL
        ========================================================= */

        .patif-footer-social-area {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 15px;
        }

        .patif-footer-social-area > span {
          color: #858e88;
          font-size: 10px;
          font-weight: 750;
          letter-spacing: 1.1px;
          text-transform: uppercase;
        }

        .patif-footer-social-links {
          display: flex;
          gap: 8px;
        }

        .patif-footer-social-links a {
          display: flex;
          align-items: center;
          justify-content: center;

          width: 36px;
          height: 36px;

          border: 1px solid rgba(255, 255, 255, 0.11);
          border-radius: 50%;

          background: rgba(255, 255, 255, 0.035);

          color: #d7ddd8;
          font-size: 12px;

          text-decoration: none;

          transition:
            background 0.3s ease,
            border-color 0.3s ease,
            color 0.3s ease,
            transform 0.3s ease;
        }

        .patif-footer-social-links a:hover {
          border-color: var(--patif-lemon);
          background: var(--patif-lemon);
          color: var(--patif-black);
          transform: translateY(-4px);
        }

        /* =========================================================
           NAVIGATION
        ========================================================= */

        .patif-footer-navigation-section {
          display: grid;
          grid-template-columns: 1fr;
          gap: 42px;
        }

        .patif-footer-column {
          position: relative;
          z-index: 2;
        }

        .patif-footer-title {
          display: flex;
          align-items: center;
          gap: 11px;
          margin-bottom: 21px;
        }

        .patif-footer-title-icon {
          display: flex;
          align-items: center;
          justify-content: center;

          width: 34px;
          height: 34px;

          border-radius: 8px;
          background: var(--patif-green-dark);

          color: var(--patif-lemon);
          font-size: 12px;
        }

        .patif-footer-title h3 {
          margin: 0;
          color: var(--patif-white);
          font-size: 15px;
          font-weight: 800;
          letter-spacing: -0.2px;
        }

        .patif-footer-column ul {
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .patif-footer-column li {
          margin-bottom: 11px;
        }

        .patif-footer-column li a {
          display: inline-flex;
          align-items: center;
          gap: 8px;

          color: #aeb7b1;
          font-size: 12px;
          font-weight: 500;

          text-decoration: none;

          transition:
            color 0.3s ease,
            transform 0.3s ease;
        }

        .patif-footer-column li a svg {
          color: var(--patif-green-bright);
          font-size: 8px;

          transition:
            color 0.3s ease,
            transform 0.3s ease;
        }

        .patif-footer-column li a:hover {
          color: var(--patif-lemon);
          transform: translateX(5px);
        }

        .patif-footer-column li a:hover svg {
          color: var(--patif-lemon);
          transform: translateX(2px);
        }

        /* =========================================================
           CONTACT
        ========================================================= */

        .patif-footer-contact-section {
          position: relative;
          z-index: 2;
        }

        .patif-footer-contact-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 11px;
        }

        .patif-footer-contact-card {
          display: flex;
          align-items: flex-start;
          gap: 12px;

          padding: 12px;

          border: 1px solid rgba(255, 255, 255, 0.07);
          border-radius: 9px;

          background: rgba(255, 255, 255, 0.025);

          transition:
            border-color 0.3s ease,
            background 0.3s ease,
            transform 0.3s ease;
        }

        .patif-footer-contact-card:hover {
          border-color: rgba(200, 242, 58, 0.27);
          background: rgba(200, 242, 58, 0.035);
          transform: translateX(4px);
        }

        .patif-footer-contact-icon {
          display: flex;
          align-items: center;
          justify-content: center;

          width: 36px;
          height: 36px;
          flex-shrink: 0;

          border-radius: 8px;

          background: rgba(22, 128, 58, 0.22);

          color: var(--patif-lemon);
          font-size: 12px;
        }

        .patif-footer-contact-card span {
          display: block;
          margin-bottom: 4px;

          color: #7e8881;
          font-size: 9px;
          font-weight: 800;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .patif-footer-contact-card p {
          margin: 0;

          color: #d0d7d2;
          font-size: 11.5px;
          line-height: 1.6;

          word-break: break-word;
        }

        /* =========================================================
           CONNECTION / NEWSLETTER
        ========================================================= */

        .patif-footer-connect {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 35px;

          max-width: 1370px;
          margin: 0 auto;

          padding: 28px 35px;

          border-top: 1px solid rgba(255, 255, 255, 0.08);
          border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        }

        .patif-footer-connect-content {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .patif-footer-connect-icon {
          display: flex;
          align-items: center;
          justify-content: center;

          width: 46px;
          height: 46px;
          flex-shrink: 0;

          border-radius: 11px;

          background: var(--patif-green);
          color: var(--patif-lemon);

          font-size: 16px;
        }

        .patif-footer-connect-content h4 {
          margin: 0 0 4px;

          color: var(--patif-white);
          font-size: 14px;
          font-weight: 750;
        }

        .patif-footer-connect-content p {
          margin: 0;

          color: #89938d;
          font-size: 11px;
          line-height: 1.5;
        }

        .patif-footer-newsletter {
          display: flex;

          width: min(100%, 500px);

          border: 1px solid rgba(255, 255, 255, 0.12);
          border-radius: 8px;

          overflow: hidden;

          background: #0d100e;
        }

        .patif-footer-newsletter input {
          min-width: 0;
          flex: 1;

          border: 0;
          outline: none;

          padding: 14px 16px;

          background: transparent;
          color: var(--patif-white);

          font-family: inherit;
          font-size: 11.5px;
        }

        .patif-footer-newsletter input::placeholder {
          color: #626b65;
        }

        .patif-footer-newsletter input:focus {
          background: rgba(200, 242, 58, 0.025);
        }

        .patif-footer-newsletter button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;

          min-width: 120px;

          border: 0;

          background: var(--patif-lemon);
          color: var(--patif-black);

          cursor: pointer;

          font-family: inherit;
          font-size: 11px;
          font-weight: 850;

          transition:
            background 0.3s ease,
            color 0.3s ease;
        }

        .patif-footer-newsletter button:hover {
          background: var(--patif-yellow);
        }

        .patif-footer-newsletter button svg {
          font-size: 10px;
        }

        .patif-footer-success {
          display: flex;
          align-items: center;
          gap: 8px;

          padding: 13px 16px;

          color: var(--patif-lemon);
          font-size: 11px;
          font-weight: 750;
        }

        /* =========================================================
           MOTTO
        ========================================================= */

        .patif-footer-motto {
          display: flex;
          align-items: center;
          gap: 20px;

          max-width: 950px;
          margin: 0 auto;

          padding: 38px 25px;
        }

        .patif-footer-motto span {
          height: 1px;
          flex: 1;

          background:
            linear-gradient(
              to right,
              transparent,
              rgba(200, 242, 58, 0.5)
            );
        }

        .patif-footer-motto span:last-child {
          background:
            linear-gradient(
              to left,
              transparent,
              rgba(200, 242, 58, 0.5)
            );
        }

        .patif-footer-motto p {
          margin: 0;

          color: var(--patif-lemon);

          font-size: 11px;
          font-weight: 800;

          text-align: center;
          letter-spacing: 1.35px;
          text-transform: uppercase;

          white-space: nowrap;
        }

        /* =========================================================
           BOTTOM FOOTER
        ========================================================= */

        .patif-footer-bottom {
          background: #050705;
          border-top: 1px solid rgba(255, 255, 255, 0.06);
        }

        .patif-footer-bottom-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 25px;

          max-width: 1480px;
          margin: 0 auto;

          padding: 22px 55px;
        }

        .patif-footer-bottom-inner > p {
          margin: 0;

          color: #727b75;

          font-size: 10.5px;
          line-height: 1.6;
        }

        .patif-footer-bottom-inner > p strong {
          color: var(--patif-lemon);
          font-weight: 700;
        }

        .patif-footer-bottom-links {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .patif-footer-bottom-links a {
          color: #707872;

          font-size: 10.5px;
          text-decoration: none;

          transition: color 0.3s ease;
        }

        .patif-footer-bottom-links a:hover {
          color: var(--patif-lemon);
        }

        .patif-footer-bottom-links span {
          color: #343a36;
          font-size: 10px;
        }

        /* =========================================================
           RESPONSIVE
        ========================================================= */

        @media (max-width: 1100px) {
          .patif-footer-main {
            grid-template-columns: 1fr 1fr;
            gap: 45px;
          }

          .patif-footer-brand-section {
            grid-column: span 2;
          }

          .patif-footer-description {
            max-width: 850px;
          }

          .patif-footer-navigation-section {
            grid-template-columns: 1fr 1fr;
          }
        }

        @media (max-width: 820px) {
          .patif-footer-main {
            grid-template-columns: 1fr;
            gap: 42px;

            padding: 58px 28px 48px;
          }

          .patif-footer-brand-section {
            grid-column: auto;
          }

          .patif-footer-navigation-section {
            grid-template-columns: 1fr 1fr;
          }

          .patif-footer-connect {
            flex-direction: column;
            align-items: stretch;

            padding: 28px;
          }

          .patif-footer-newsletter {
            width: 100%;
          }

          .patif-footer-bottom-inner {
            flex-direction: column;
            align-items: flex-start;

            padding: 22px 28px;
          }
        }

        @media (max-width: 600px) {
          .patif-footer-brand {
            align-items: flex-start;
          }

          .patif-footer-brand-icon {
            width: 52px;
            height: 52px;
            font-size: 23px;
          }

          .patif-footer-brand-text h2 {
            font-size: 18px;
          }

          .patif-footer-brand-text span {
            font-size: 8.5px;
            letter-spacing: 1px;
          }

          .patif-footer-navigation-section {
            grid-template-columns: 1fr;
            gap: 34px;
          }

          .patif-footer-values {
            display: grid;
            grid-template-columns: 1fr 1fr;
          }

          .patif-footer-value {
            width: 100%;
            box-sizing: border-box;
          }

          .patif-footer-social-area {
            align-items: flex-start;
            flex-direction: column;
          }

          .patif-footer-connect {
            padding: 25px 20px;
          }

          .patif-footer-newsletter {
            display: flex;
            flex-direction: column;

            border: 0;
            overflow: visible;

            background: transparent;
            gap: 8px;
          }

          .patif-footer-newsletter input {
            width: 100%;
            box-sizing: border-box;

            border: 1px solid rgba(255, 255, 255, 0.12);
            border-radius: 8px;

            background: #0d100e;

            padding: 14px;
          }

          .patif-footer-newsletter button {
            width: 100%;
            min-height: 45px;
            border-radius: 8px;
          }

          .patif-footer-motto {
            padding: 32px 20px;
          }

          .patif-footer-motto span {
            display: none;
          }

          .patif-footer-motto p {
            width: 100%;

            white-space: normal;
            line-height: 1.65;
          }

          .patif-footer-bottom-inner {
            padding: 22px 20px;
          }

          .patif-footer-bottom-links {
            gap: 8px;
          }
        }

        @media (max-width: 420px) {
          .patif-footer-main {
            padding-left: 18px;
            padding-right: 18px;
          }

          .patif-footer-values {
            grid-template-columns: 1fr;
          }

          .patif-footer-brand-text h2 {
            font-size: 16px;
          }

          .patif-footer-description {
            font-size: 13px;
          }

          .patif-footer-bottom-links {
            flex-direction: column;
            align-items: flex-start;
          }

          .patif-footer-bottom-links span {
            display: none;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .patif-footer *,
          .patif-footer *::before,
          .patif-footer *::after {
            scroll-behavior: auto !important;
            transition: none !important;
            animation: none !important;
          }
        }
      `}</style>

      {/* =========================================================
          TOP ACCENT
      ========================================================= */}

      <div className="patif-footer-accent">
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* =========================================================
          MAIN FOOTER
      ========================================================= */}

      <div className="patif-footer-main">

        {/* =======================================================
            BRAND
        ======================================================= */}

        <div className="patif-footer-brand-section">

          <div className="patif-footer-brand">

            <div className="patif-footer-brand-icon">
              <FaHeart />
            </div>

            <div className="patif-footer-brand-text">

              <h2>
                PASSION AIDS
                <br />
                THE FUTURE
              </h2>

              <span>
                Professional • Vocational • Leadership
              </span>

            </div>

          </div>

          <p className="patif-footer-description">
            PASSION AIDS THE FUTURE is committed to accessible,
            practical and professional education that transforms
            passion into knowledge, knowledge into skills, and skills
            into meaningful opportunities for individuals,
            organizations and communities.
          </p>

          <div className="patif-footer-values">

            <div className="patif-footer-value">
              <FaGraduationCap />
              <span>Professional Education</span>
            </div>

            <div className="patif-footer-value">
              <FaLightbulb />
              <span>Practical Skills</span>
            </div>

            <div className="patif-footer-value">
              <FaUsers />
              <span>Leadership Development</span>
            </div>

            <div className="patif-footer-value">
              <FaBriefcase />
              <span>Career Opportunity</span>
            </div>

          </div>

          <div className="patif-footer-institution-badge">
            <FaCheckCircle />
            Empowering people through education, skills and opportunity.
          </div>

          <div className="patif-footer-social-area">

            <span>
              Connect With Us
            </span>

            <div className="patif-footer-social-links">

              <a
                href="#"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>

              <a
                href="#"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>

              <a
                href="#"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>

            </div>

          </div>

        </div>

        {/* =======================================================
            NAVIGATION
        ======================================================= */}

        <div className="patif-footer-navigation-section">

          {/* QUICK LINKS */}

          <div className="patif-footer-column">

            <div className="patif-footer-title">

              <span className="patif-footer-title-icon">
                <FaArrowRight />
              </span>

              <h3>
                Quick Links
              </h3>

            </div>

            <ul>

              <li>
                <a href="#home">
                  <FaChevronRight />
                  <span>Home</span>
                </a>
              </li>

              <li>
                <a href="#about">
                  <FaChevronRight />
                  <span>About Us</span>
                </a>
              </li>

              <li>
                <a href="#programs">
                  <FaChevronRight />
                  <span>Our Programs</span>
                </a>
              </li>

              <li>
                <a href="#admissions">
                  <FaChevronRight />
                  <span>Admissions</span>
                </a>
              </li>

              <li>
                <a href="#contact">
                  <FaChevronRight />
                  <span>Contact Us</span>
                </a>
              </li>

            </ul>

          </div>

          {/* FOCUS AREAS */}

          <div className="patif-footer-column">

            <div className="patif-footer-title">

              <span className="patif-footer-title-icon">
                <FaBullseye />
              </span>

              <h3>
                Focus Areas
              </h3>

            </div>

            <ul>

              <li>
                <a href="#education">
                  <FaChevronRight />
                  <span>Professional Education</span>
                </a>
              </li>

              <li>
                <a href="#vocational">
                  <FaChevronRight />
                  <span>Vocational Skills</span>
                </a>
              </li>

              <li>
                <a href="#leadership">
                  <FaChevronRight />
                  <span>Leadership Development</span>
                </a>
              </li>

              <li>
                <a href="#entrepreneurship">
                  <FaChevronRight />
                  <span>Entrepreneurship</span>
                </a>
              </li>

              <li>
                <a href="#community">
                  <FaChevronRight />
                  <span>Community Empowerment</span>
                </a>
              </li>

              <li>
                <a href="#justice">
                  <FaChevronRight />
                  <span>Compliance & Justice</span>
                </a>
              </li>

            </ul>

          </div>

        </div>

        {/* =======================================================
            CONTACT
        ======================================================= */}

        <div className="patif-footer-contact-section">

          <div className="patif-footer-title">

            <span className="patif-footer-title-icon">
              <FaMapMarkerAlt />
            </span>

            <h3>
              Contact Us
            </h3>

          </div>

          <div className="patif-footer-contact-grid">

            <div className="patif-footer-contact-card">

              <div className="patif-footer-contact-icon">
                <FaMapMarkerAlt />
              </div>

              <div>

                <span>
                  Visit Us
                </span>

                <p>
                  Johnsonville, Monrovia, Liberia
                </p>

              </div>

            </div>

            <div className="patif-footer-contact-card">

              <div className="patif-footer-contact-icon">
                <FaPhoneAlt />
              </div>

              <div>

                <span>
                  Call Us
                </span>

                <p>
                  +231-776-4940-10
                  <br />
                  +231-880-5858-55
                </p>

              </div>

            </div>

            <div className="patif-footer-contact-card">

              <div className="patif-footer-contact-icon">
                <FaEnvelope />
              </div>

              <div>

                <span>
                  Email Us
                </span>

                <p>
                  info@passionaids.org
                </p>

              </div>

            </div>

            <div className="patif-footer-contact-card">

              <div className="patif-footer-contact-icon">
                <FaClock />
              </div>

              <div>

                <span>
                  Office Hours
                </span>

                <p>
                  Mon - Fri: 8:00 AM - 4:00 PM
                </p>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* =========================================================
          NEWSLETTER / CONNECTION
      ========================================================= */}

      <div className="patif-footer-connect">

        <div className="patif-footer-connect-content">

          <div className="patif-footer-connect-icon">
            <FaEnvelope />
          </div>

          <div>

            <h4>
              Stay Connected
            </h4>

            <p>
              Receive program news, admission information and
              institutional updates.
            </p>

          </div>

        </div>

        {subscribed ? (

          <div className="patif-footer-success">
            <FaCheckCircle />
            Thank you! You are now connected with us.
          </div>

        ) : (

          <form
            className="patif-footer-newsletter"
            onSubmit={handleSubscribe}
          >

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              aria-label="Email address"
              required
            />

            <button
              type="submit"
              aria-label="Subscribe to newsletter"
            >
              Subscribe
              <FaPaperPlane />
            </button>

          </form>

        )}

      </div>

      {/* =========================================================
          BRAND MOTTO
      ========================================================= */}

      <div className="patif-footer-motto">

        <span></span>

        <p>
          Passion • Education • Skills • Leadership • Opportunity
        </p>

        <span></span>

      </div>

      {/* =========================================================
          COPYRIGHT
      ========================================================= */}

      <div className="patif-footer-bottom">

        <div className="patif-footer-bottom-inner">

          <p>
            © {currentYear}{" "}
            <strong>
              PASSION AIDS THE FUTURE
            </strong>
            . All Rights Reserved.
          </p>

          <div className="patif-footer-bottom-links">

            <a href="#privacy">
              Privacy Policy
            </a>

            <span>|</span>

            <a href="#terms">
              Terms & Conditions
            </a>

            <span>|</span>

            <a href="#support">
              System Support
            </a>

          </div>

        </div>

      </div>

    </footer>
  );
}